/** Compatibility export; the business domain owns this implementation. */
export { IAiMetaInfo, IImageColors, IImageResolution, IImageUrl, IListColor, IPodImage, ImageResolutionSchema } from '@domains/upload/shared';
